(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-default"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-default"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    customElements.define('nav-menu', NavMenu);
  });
  /* === WM: Mobile drawer — always start at first item === */
document.addEventListener('DOMContentLoaded', () => {
  const disclosure = document.querySelector('main-menu .main-menu__disclosure');
  if (!disclosure) return;

  const toggleBtn  = disclosure.querySelector('.main-menu__toggle');
  const content    = disclosure.querySelector('.main-menu__content');
  const firstItem  = disclosure.querySelector('.main-nav > li:first-child');

  // Make sure the drawer content can scroll to the very top
  if (content) content.style.overflowY = 'auto';

  function snapToTop() {
    if (content) content.scrollTop = 0;
    if (firstItem) {
      // behavior:'instant' isn’t universal; fall back to 'auto'
      try { firstItem.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' }); }
      catch { firstItem.scrollIntoView(true); }
    }
  }

  // When the <details> actually opens
  disclosure.addEventListener('toggle', () => {
    if (disclosure.open) {
      // wait a tick for any open animation/layout
      requestAnimationFrame(() => setTimeout(snapToTop, 120));
    }
  });

  // Also run on burger click (covers some Safari timing quirks)
  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      requestAnimationFrame(() => setTimeout(snapToTop, 120));
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
